/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Apikeys_Key_NameInputs */

const en_settings_apikeys_key_name = /** @type {(inputs: Settings_Apikeys_Key_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Key Name`)
};

/**
* | output |
* | --- |
* | "Key Name" |
*
* @param {Settings_Apikeys_Key_NameInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const settings_apikeys_key_name = /** @type {((inputs?: Settings_Apikeys_Key_NameInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Apikeys_Key_NameInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_settings_apikeys_key_name(inputs)
});
export { settings_apikeys_key_name as "settings.apikeys.key_name" }